import { render, staticRenderFns } from "./WorkOrderTotals.vue?vue&type=template&id=386a8c77&scoped=true"
import script from "./WorkOrderTotals.vue?vue&type=script&lang=js"
export * from "./WorkOrderTotals.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderTotals.vue?vue&type=style&index=0&id=386a8c77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a8c77",
  null
  
)

export default component.exports